<template>
    <CobaltSidebar 
        ref="sidebar"
        :isCollapsed="isCollapsed" 
        :project="project" 
        :company="company"
    />    

    <div class="np-group np-group-column np-roundless np-flex-1">
        <CobaltHeader 
            :info="info" 
            :company="company" 
            :project="project" 
            :isCollapsed="isCollapsed" 
            @toggle="toggle"
            @toggleInviteModal="toggleInviteModal"
        />    

        <div class="np-content np-flex-1 np-pb-0" :class="dashboardClasses">  
            <div class="dashboard-content__filters w-100" v-if="withFilterBar">
                <div class="dashboard-content__filters-panel me-3">
                    <button type="button" class="btn btn-sm filters-panel__button group" @click="toggleDashboardMode('dashboard')" :class = "{'active' : this.currentMode == 'dashboard'}">
                        <img src="@/assets/images/dashboard/base-home.svg" class="me-1"> {{ $t('UI.dashboard.dashboard') }}
                    </button>                         
                    <button type="button" class="btn btn-sm filters-panel__button group" @click="toggleDashboardMode('canban')" :class = "{'active' : this.currentMode == 'canban'}">
                        <img src="@/assets/images/dashboard/base-canban.svg" class="me-1"> {{ $t('UI.dashboard.canban') }}
                    </button>   
                    <button type="button" class="btn btn-sm filters-panel__button group" @click="toggleDashboardMode('calendar')" :class = "{'active' : this.currentMode == 'calendar'}">
                        <img src="@/assets/images/dashboard/base-calendar.svg" class="me-1"> {{ $t('UI.dashboard.calendar') }}
                    </button>
                    <!--
                        <button type="button" class="btn btn-sm me-2 filters-panel__button disabled">
                            <img src="@/assets/images/dashboard/base-gantt.svg" class="me-1"> {{ $t('UI.dashboard.gantt') }}
                        </button>                                                                                 
                    -->
                </div>   
                <div class="dashboard-content__filters-panel flex-grow-1 me-3" v-if="this.currentMode != 'calendar' && this.currentMode != 'dashboard'">
                    <div class="ms-1 me-2"><img src="@/assets/images/dashboard/base-filter.svg"></div>
                    <input type="text" class="form-control filters-panel__input me-2" id="filter" :placeholder="$t('UI.dashboard.filter')" disabled />  
                </div>  
                <div class="dashboard-content__filters-panel" v-if="this.currentMode != 'calendar' && this.currentMode != 'dashboard'">
                    <div class="ms-1 me-2"><img src="@/assets/images/dashboard/base-sort.svg"></div>
                    <input type="text" class="form-control filters-panel__input me-2" id="sorting" :placeholder="$t('UI.dashboard.sort')" disabled />  
                </div>   
                <div class="dashboard-content__filters-panel transparent flex-grow-1" v-if="this.currentMode == 'dashboard'">
                    <button class="btn btn-sm me-2 filters-panel__button" @click="this.showProjectSettings()">
                        <font-awesome-icon :icon="['fas', 'gear']" class="me-2"/>
                        {{ $t("UI.dashboard.projectSettings") }}
                    </button>
                </div>                       
                <button v-if="this.currentMode == 'canban'" class="btn btn-lg cobalt-status-column__button ms-3" @click="this.$emit('showMod', 0)">{{ $t("UI.addStatus") }}</button>                                                 
            </div>
            
            <slot></slot>

        </div>
    </div>


    <InviteModal 
        modalID='modalInvite' 
        modalSize="modal-md" 
        modalPosition="center" 
        ref="InviteModal" 
        class="cobalt-base-dialog" 
    />

    <ProjectModal 
        v-if="this.currentMode == 'dashboard'"
        modalID='modalProjectSettings' 
        @refresh="refresh"
        ref="projectModal" 
    />

</template>

<script>
import CobaltHeader from "@/components/dashboard/CobaltHeader.vue";
import CobaltSidebar from "@/components/dashboard/CobaltSidebar.vue";
import InviteModal from "@/components/modals/InviteModal.vue"
import ProjectModal from "@/components/modals/ProjectModal.vue"
import Multiselect from 'vue-multiselect'
import { createToast } from 'mosha-vue-toastify';   
import 'mosha-vue-toastify/dist/style.css'
import { ref } from 'vue'
import { mapGetters, mapActions } from 'vuex'
import Config from '../../config.js'

export default {
    components: {
        CobaltHeader,
        CobaltSidebar,
        InviteModal,
        ProjectModal,
        Multiselect
    },
    emits: ['switchMode', 'showMod', 'refresh'],
    props: ['contentClasses', 'dashboardClasses', 'info', 'company', 'project', 'withFilterBar', 'isSingle'],    
    data() {
        return {
            currentMode: 'canban', // default mode
            isCollapsed: false,
            inviteObject: {},
            inviteEmail: '',
            availableRoles: [],
            selectedRole: null,

            Config
        }
    },
    computed: {
        currentRoute: {
            get() {     
                const hostName = window.location.origin
                return hostName
            }
        }
    },
    methods: {
        ...mapActions('company', ['inviteCode', 'sendInvitation']),
        ...mapActions('project', {getProjectInviteCode: 'inviteCode'}),
        ...mapActions('roles', ['listRoles']),
        ...mapGetters('roles', ['getListRoles']),

        toggle(mode) {
            //
        },
        async toggleInviteModal() {
            if (this.project && this.project.id) {
                this.$refs.InviteModal.shows(1, this.project.id)
            } else {
                this.$refs.InviteModal.shows(0, this.company.id)
            }          
        },
        toggleDashboardMode(mode) {
            this.currentMode = mode
            this.$emit('switchMode', mode)
        },
        refreshSidebar() {
            this.$refs.sidebar.refresh()
        },
        async copy(event) {
            try {
                await navigator.clipboard.writeText(event.target.textContent);
                
                createToast({ description: this.$t("UI.linkCopied") }, {
                    hideProgressBar: true,
                    timeout: 1000,
                    position: 'bottom-center',
                    transition: 'slide',
                    showIcon: false,
                    showCloseButton: false,
                    swipeClose: false,
                })
            } catch($e) {
                alert('Cannot copy')
            }
        },
        showProjectSettings() {
            this.$refs.projectModal.shows(this.project.company_id, this.project)
        },
        refresh() {
            this.$emit('refresh')
        }         
    }
}
</script>
<style>
    .mosha__toast {
        justify-content:center;
    }
    .mosha__toast.default {
        background-color: #142941;
        max-height: 48px;
        min-height: 36px;
    }  
    .mosha__toast.default .mosha__toast__content {
        color: #FFF;
    }    
    .mosha__toast__content-wrapper {
        max-height: 48px;
    }
</style>